import * as utils from "./utils";

export function underwriterToSelect(underwriters) {
    let cleanedUnderwriters = [];

    underwriters.map((item) => {
        if (item.isUnderwriter === true) {
            cleanedUnderwriters.push({
                label: item.name,
                value: item.id,
                item: item,
            })
        }

        return item;
    });

    return cleanedUnderwriters;
}

export function companyToSelect(companies) {
    let cleanedCompanies = [];

    companies.map((item) => {
        if (item.isUnderwriter === false) {
            cleanedCompanies.push({
                label: item.name,
                value: item.id,
                item: item,
            })
        }

        return item;
    });

    return cleanedCompanies;
}

export function underwriterToForm(underwriter) {
    let cleanedUnderwriter = Object.assign({}, underwriter);

    if (cleanedUnderwriter.country !== undefined && cleanedUnderwriter.country.id !== undefined) {
        cleanedUnderwriter.country = cleanedUnderwriter.country.id;
    }

    return cleanedUnderwriter;
}

export function flattenCountry(items) {
    let newItems = [];
    for (let i = 0; i < items.length; i++) {
        let newItem = items[i];
        if (utils.notNullNorUndefined(newItem.country)) {
            newItems.push({...newItem, countryName: newItem.country.name});
        } else {
            newItems.push(newItem);
        }
    }
    return newItems;
}


// WEBPACK FOOTER //
// ./src/utils/underwriter.js